module.exports = "/assets/09408eda6ace421f9b4968b1d9b191fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/BH.png
// module id = 1230
// module chunks = 0